// Products without a photo used to render <img src="">, which browsers draw as a
// broken-image icon. This is the stand-in: an inline SVG, so it needs no network
// request and cannot itself fail to load.
//
// The background is almost transparent (a 7% wash of the brand gold) so the same
// image sits on a white card in light mode and a navy card in dark mode; only the
// thin gold line drawing and the small label carry colour.
export const PRODUCT_PLACEHOLDER =
  'data:image/svg+xml;charset=utf-8,' +
  encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" role="img" aria-label="Photo coming soon">
  <rect width="400" height="400" fill="#BB976D" fill-opacity="0.07"/>
  <g fill="none" stroke="#BB976D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
    <path d="M140 198v-42a20 20 0 0 1 20-20h80a20 20 0 0 1 20 20v42"/>
    <path d="M128 198a14 14 0 0 1 14 14v12h116v-12a14 14 0 0 1 14-14h4a14 14 0 0 1 14 14v44H110v-44a14 14 0 0 1 14-14Z"/>
    <path d="M142 224h116"/>
    <path d="M200 224v32" opacity="0.6"/>
    <path d="M126 270v16M274 270v16"/>
    <path d="M100 302h200" opacity="0.35"/>
  </g>
  <text x="200" y="340" font-family="'Josefin Sans', 'Helvetica Neue', Arial, sans-serif" font-size="12" letter-spacing="3.5" fill="#BB976D" fill-opacity="0.85" text-anchor="middle">PHOTO COMING SOON</text>
</svg>`.trim());

/** Use the given image, or the placeholder when there isn't one. */
export const productImage = (url) => url || PRODUCT_PLACEHOLDER;
